import { IconButton, Tooltip } from '@chakra-ui/react';
import { appConfig } from '../../../config/app';
function BackToViz({ t, icon, name }: any) {
    const handleOnClick = () => {
        window.location.href = '/';
    };
    if (!appConfig?.basePath) {
        return null;
    }
    return (
        <Tooltip
            aria-label={'Switch Platform'}
            label={t(`ui.mm.tooltip.${name}`)}
            hasArrow>
            <IconButton
                variant="navbar"
                aria-label={`Switch Platform`}
                icon={icon}
                p="10px"
                ml="15px"
                onClick={handleOnClick}
            />
        </Tooltip>
    );
}

export default BackToViz;
